<!--  -->
<template>
  <div>
    <div class="chsikew">
      <el-tag v-if="wechatid" style="margin-right:10px">{{ wechatname }}</el-tag>
      <el-button type="primary" size="mini" @click="choosewecaht">选择小程序</el-button>
    </div>
    <div class="chsikew">
      <el-tag v-if="configureid" style="margin-right:10px">{{ configurename }}</el-tag>
      <el-button type="primary" size="mini" @click="chooseaccount">选择配置</el-button>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" style="margin-left:430px;margin-top:60px" @click="sureclick">确 定</el-button>
    </span>
    <el-dialog
      title="选择绑定的小程序"
      :visible.sync="dialogVisiblewechat"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="30%"
    >
      <chhosewechat ref="chhosewecahtr" @callback="callback" />
    </el-dialog>
    <el-dialog
      title="选择绑定的配置"
      :visible.sync="dialogVisibleaccount"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="30%"
    >
      <chhoseaccount ref="chhoseaccount" @callbackr="callbackr" />
    </el-dialog>
  </div>
</template>

<script>
import chhosewechat from './chhosewechat.vue'
import chhoseaccount from './chhoseaccount.vue'
import { turntableconfigbind, createturntableconfigbind } from '@/api/sourceMaterial.js'
export default {
  components: {
    chhosewechat,
    chhoseaccount
  },
  data() {
    return {
      wechat: null,
      configure: null,
      dialogVisiblewechat: false,
      dialogVisibleaccount: false,
      wechatname: null,
      wechatid: null,
      configurename: null,
      configureid: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send() {

    },
    sureclick() {
      if (this.wechatid === null) {
        this.$message.error('请选择小程序')
        return
      }
      if (this.configureid === null) {
        this.$message.error('请选择配置')
        return
      }
      turntableconfigbind({
        app_id: this.wechatid
      }).then((res) => {
        console.log('res', res)
        // eslint-disable-next-line eqeqeq
        if (res.code == 200) {
          createturntableconfigbind({
            config_id: this.configureid,
            app_id: this.wechatid
          }).then((res) => {
            this.$message({
              message: '创建成功',
              type: 'success'
            })
            this.$emit('close')
          })
        }
      }).catch((err) => {
        console.log('err', err.message)
        this.$confirm(`${err.message}, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // })
          createturntableconfigbind({
            config_id: this.configureid,
            app_id: this.wechatid
          }).then((res) => {
            this.$message({
              message: '创建成功',
              type: 'success'
            })
            this.$emit('close')
          })
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
      })
    },
    choosewecaht() {
      this.dialogVisiblewechat = true
      this.$nextTick(() => {
        this.$refs.chhosewecahtr.send()
      })
    },
    callback(item) {
      this.dialogVisiblewechat = false
      this.wechatname = item.account_name
      this.wechatid = item.app_id
      console.log('item', item)
    },
    chooseaccount() {
      this.dialogVisibleaccount = true
      this.$nextTick(() => {
        this.$refs.chhoseaccount.send()
      })
    },
    callbackr(item) {
      this.dialogVisibleaccount = false
      this.configurename = item.title
      this.configureid = item.id
      console.log('item', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.chsikew{
  display: flex;
  align-items: center;
  margin-top: 10px;
}
</style>
